import { render } from "./favouritePrograms.vue?vue&type=template&id=11292fbc&scoped=true"
import script from "./favouritePrograms.vue?vue&type=script&lang=js"
export * from "./favouritePrograms.vue?vue&type=script&lang=js"

import "./favouritePrograms.vue?vue&type=style&index=0&id=11292fbc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11292fbc"]])

export default __exports__